import { render, staticRenderFns } from "./PhotoUploadGridModule.vue?vue&type=template&id=4c05387b&scoped=true"
import script from "./PhotoUploadGridModule.vue?vue&type=script&lang=js"
export * from "./PhotoUploadGridModule.vue?vue&type=script&lang=js"
import style0 from "./PhotoUploadGridModule.vue?vue&type=style&index=0&id=4c05387b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c05387b",
  null
  
)

export default component.exports